import GoogleMeetServices from "../../../services/GoogleMeetService";

const STORAGE_KEY = "google_auth";
const MILLISECONDS_TO_SECONDS = 1000;

export function getGoogleAuth() {
  const raw = localStorage.getItem(STORAGE_KEY);
  return raw ? JSON.parse(raw) : null;
}

export function setGoogleAuth(token) {
  const expires_at =
    Math.floor(Date.now() / MILLISECONDS_TO_SECONDS) + token.expires_in;

  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ ...token, expires_at })
  );
}

export function clearGoogleAuth() {
  localStorage.removeItem(STORAGE_KEY);
}

export function isExpired(token) {
  return !token?.expires_at ||
    Math.floor(Date.now() / 1000) >= token.expires_at;
}

export async function getValidGoogleAccessToken() {
  const token = getGoogleAuth();
  if (!token) return null;

  if (!isExpired(token)) return token.access_token;

  if (!token.refresh_token) {
    clearGoogleAuth();
    return null;
  }

  try {
    const refreshed =
      await GoogleMeetServices.refreshToken(token.refresh_token);

    setGoogleAuth(refreshed);
    return refreshed.access_token;
  } catch (err) {
    clearGoogleAuth();
    return null;
  }
}


